export default function teamCareurl() {
  const target = (process.env.REACT_APP_TARGET || "dev").trim();
  const careUrl =
    target === "prod"
      ? "https://care.perceptionhealth.com/"
      : `https://care-${target}.mi.huronconsultinggroup.com/`;
  const teamUrl =
    target === "prod"
      ? "https://team.perceptionhealth.com/"
      : `https://team-${target}.mi.huronconsultinggroup.com/`;

  return { careUrl, teamUrl };
}
